/**
 * Der Kopplungslink, den das Gerät anzeigt.
 *
 * Ein Gerät nennt beim Koppeln eine Adresse wie `…/verbinden?code=K7M2QF`
 * (`claimUrl`, ADR 0018). Sie ist seit dem Router eine **richtige Route**
 * (`lib/router.ts`) und kein Tiefenverweis mehr, der beim Start einmal gelesen und
 * anschließend aus der Adressleiste geputzt wird.
 *
 * Was bleibt, ist die Prüfung des Codes — und die gehört hierher und nicht in den
 * Router: Sie beschreibt, wie ein Gerät Codes bildet, nicht wie diese Anwendung
 * Adressen liest.
 *
 * Aufgeräumt wird die Adresse weiterhin, nur nicht mehr von Hand: Sobald der Code
 * übernommen ist, ersetzt der Rahmen sie durch die Geräteverwaltung der Anlage.
 * Ohne das führte ein Neuladen erneut hierher — mit einem längst verbrauchten Code.
 */

/** Der Pfad, auf den `claimUrl` zeigt. Muss zu `PUBLIC_WEB_URL` der API passen. */
export const CLAIM_PATH = "/verbinden";

/**
 * Prüft einen Kopplungscode aus der Adresse.
 *
 * Sechs Zeichen aus dem Vorrat ohne I, O, 0 und 1 (ADR 0018). Was nicht passt,
 * stammt nicht von einem Gerät — und ein Formular damit zu füllen, führte nur zu
 * einer Fehlermeldung, die niemand versteht.
 */
export function parseClaimCode(raw: string | null): string | null {
  if (raw === null) return null;

  const trimmed = raw.trim().toUpperCase();
  return /^[A-HJ-NP-Z2-9]{6}$/u.test(trimmed) ? trimmed : null;
}
